<div class="tableColumn">
  <dynamicComponentLoader *ngIf="!!dynamicComponent" [dynamicComponent]="dynamicComponent"> </dynamicComponentLoader>
</div>
